import React from 'react'
import { Stepper, styled, Step, StepLabel } from '@mui/material'
import StepConnector, {
    stepConnectorClasses
} from '@mui/material/StepConnector'
import '../../Styles/Stepper.css'
import PropTypes from 'prop-types'
import RoundedCheck from '../Icon/RoundedCheck'
import { cn } from '../../lib/utils'

const StepperCompenent = ({ activeStep = 0, stepsData ,className}) => {
    const StepperConnector = styled(StepConnector)(({ theme }) => ({
        [`&.${stepConnectorClasses.alternativeLabel}`]: {
            top: 10,
            left: 'calc(-50% + 24px)',
            right: 'calc(50% + 24px)'
        },
        [`&.${stepConnectorClasses.active}`]: {
            [`& .${stepConnectorClasses.line}`]: {
                borderColor: 'hsl(var(--border))'
            }
        },
        [`&.${stepConnectorClasses.completed}`]: {
            [`& .${stepConnectorClasses.line}`]: {
                borderColor: 'hsl(var(--primary))'
            }
        },
        [`& .${stepConnectorClasses.line}`]: {
            borderColor:
        theme.palette.mode === 'dark' ? theme.palette.grey[800] : 'hsl(var(--border))',
            borderTopWidth: 1,
            borderRadius: 1
        }
    }))

    const StepperIconRoot = styled('div')(({ theme, ownerState }) => ({
        color: theme.palette.mode === 'dark' ? theme.palette.grey[700] : 'hsl(var(--muted))',
        display: 'flex',
        height: 22,
        alignItems: 'center',
        ...(ownerState.active && {
            color: 'hsl(var(--muted))'
        }),
        '& .QontoStepIcon-completedIcon': {
            color: 'hsl(var(--primary))',
            zIndex: 1,
            fontSize: 18
        },
        '& .QontoStepIcon-circle': {
            width: 10,
            height: 10,
            borderRadius: '50%',
            backgroundColor: 'currentColor'
        }
    }))

    const StepperIcon = (props) => {
        const { active, completed, className, icon } = props

        return (
            <StepperIconRoot
                ownerState={{ active }}
                className={className}
            >
                {completed
                    ? (<RoundedCheck />)
                    : (active
                        ? (<div className="stepper-active-icon-container">
                            <div className="stepper-active-icon-circle">{icon}</div>
                        </div>)
                        : (<div className="stepper-inactive-circle" />))}
            </StepperIconRoot>
        )
    }

    const titleLableColor = (active, stepIndex) => {
        let className = ''
        if (active === stepIndex) {
            className = 'active'
        } else if (active > stepIndex) {
            className = 'completed'
        }

        return className
    }

    return (
        <div className={cn("stepper-card-container", className)}>
            <Stepper
                alternativeLabel
                activeStep={activeStep}
                connector={<StepperConnector />}
            >
                {stepsData?.map((label, index) => (
                    <Step key={index}>
                        <StepLabel StepIconComponent={StepperIcon}>
                            <div>
                                <p className={`stepper-label-title ${titleLableColor(activeStep, index)}`}>{label?.label}</p>
                            </div>
                        </StepLabel>
                    </Step>)
                )}
            </Stepper>
        </div>
    )
}

StepperCompenent.propTypes = {
    activeStep: PropTypes.number,
    active: PropTypes.number,
    completed: PropTypes.number,
    className: PropTypes.number,
    stepsData: PropTypes.array
}

export default StepperCompenent
